module.exports = __webpack_public_path__ + "static/media/tineye.c7f4a94b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/partners-hover/tineye.png
// module id = 2904
// module chunks = 1